import {
  createStore,
  applyMiddleware,
  combineReducers,
  type Store,
} from 'redux';
import thunk, { type ThunkMiddleware } from 'redux-thunk';
import { registerHistoryDispatch } from "../document-lifecycle";
import { editorReducer } from "./editorReducer";
import type {
  EditorAction,
  EditorRootState,
  EditorThunkAction,
} from "./types";

const rootReducer = combineReducers({
  editor: editorReducer,
});

export type AppDispatch = {
  (action: EditorAction): EditorAction;
  (action: EditorThunkAction): EditorThunkAction;
};

export const editorReduxStore: Store<EditorRootState, EditorAction> & {
  dispatch: AppDispatch;
} = createStore(
  rootReducer,
  applyMiddleware(
    thunk as ThunkMiddleware<EditorRootState, EditorAction, undefined>,
  ),
) as Store<EditorRootState, EditorAction> & { dispatch: AppDispatch };

registerHistoryDispatch(action => {
  editorReduxStore.dispatch(action);
});

export function getEditorRootState(): EditorRootState {
  return editorReduxStore.getState();
}

export function runEditorThunk(thunk: EditorThunkAction): void {
  void thunk(editorReduxStore.dispatch, getEditorRootState);
}
